import React from 'react'

export default function Preloader() {
  return (
      <div id="pageloader">
          <img className='preloader__image1' src="/assets/images/loader.png" alt="Loading......" />
      </div>    
  )
}
